import { z } from 'zod/v4';

import { createdAtSchemaLegacy, styleBagSchema } from '../../../common/schemas/legacy';

import { paymentFormLegacyZeroDataSchema } from './data';

/**
 * Zero-block-placement legacy payment-form envelope.
 *
 * `type: z.literal('zero')` is required (no `.optional()`): a payment form
 * created inside a zero block must carry the tag end-to-end so downstream
 * consumers (positioning hosts, render branches) recognise the placement. The
 * host-app factory copies `meta.type` onto the entity at creation time.
 *
 * Inner data uses {@link paymentFormLegacyZeroDataSchema} — the
 * extended-position grid instead of the default variant's simple grid.
 */
export const paymentFormLegacyZeroV0Schema = z.object({
    id: z.string(),
    name: z.literal('payment'),
    columnId: z.string(),
    structureId: z.string().nullish(),
    displayId: z.string().nullish(),
    createdAt: createdAtSchemaLegacy,
    type: z.literal('zero'),
    data: paymentFormLegacyZeroDataSchema,
    styles: styleBagSchema.nullish(),
    mobileStyles: styleBagSchema.nullish(),
});
